import Axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { SerializedError } from "@reduxjs/toolkit";
import "./loading.scss";
import {
  getAccessToken,
  getWorkspaceCode,
  removeAccessToken,
  removeUserInfoFromLocalStorage,
} from "./auth";
import { startProgress, stopProgress } from "../../redux/store/progress";
import { stores } from "../../App";
import utilsCommon from "./common";
import utilsClient from "./client";
const axiosBlob = Axios.create({
  withCredentials: true,
  headers: {
    locale: "kr-KR",
    "Accept-Language": window.navigator.language.includes("ko")
      ? "ko"
      : ["jp", "ja"].includes(window.navigator.language)
      ? "jp"
      : "en",
  },
  responseType: "arraybuffer",
});

let alramCount = 0;
axiosBlob.interceptors.request.use(
  function (config: InternalAxiosRequestConfig) {
    stores.dispatch(startProgress());

    //(Loading);
    // 요청을 보내기 전에 수행할 일
    // ...
    const token = getAccessToken() as string | "";
    const dsdCode = getWorkspaceCode() as string | "";
    if (token) {
      config.headers.set("X-FASOO-API-TOKEN", token);
      if (window.eco.serviceType === "OCI") {
        config.headers.set("X-FASOO-DSDCODE", dsdCode ?? "MTECOCOMMON00001");
      }
    }
    return config;
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일
    // ...
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axiosBlob.interceptors.response.use(
  (response) => {
    stores.dispatch(stopProgress());
    //document.body.classList.remove('loading-indicator');
    if (response.config.url?.includes("eco-gateway/wapi/dashboard/myAlarms")) {
      alramCount++;
    } else {
      alramCount = 0;
    }
    if (alramCount === 72) {
      removeAccessToken();
      removeUserInfoFromLocalStorage();
      window.location.reload();
    }
    return response;
  },
  async (error: AxiosError) => {
    stores.dispatch(stopProgress());

    // 오류 응답을 처리
    // ...
    let se: SerializedError;

    if (error.response) {
      // const errorData = error.response.data as any;
      let errorData: any = {};
      try {
        const raw = error.response?.data;

        if (raw instanceof ArrayBuffer || raw instanceof Uint8Array) {
          const arrayBuffer = raw instanceof Uint8Array ? raw.buffer : raw;
          const decodedString = new TextDecoder("utf-8").decode(
            arrayBuffer as any
          );
          const clean = decodedString.replace(/\u0000/g, "").trim();
          errorData = JSON.parse(clean);
        } else if (raw instanceof Blob) {
          const text = await raw.text();
          errorData = JSON.parse(text);
        } else if (typeof raw === "string") {
          errorData = JSON.parse(raw);
        } else {
          errorData = raw;
        }
      } catch (e) {
        errorData = {};
      }

      // if (error.response.status === 401) {
      //   removeToken();
      //   removeUser();
      //   window.location.reload();
      //   return;
      // }
      if (errorData.errorCode) {
        switch (errorData.errorCode) {
          case "INVALID_SESSION":
            removeAccessToken();
            removeUserInfoFromLocalStorage();
            if (
              !(
                utilsCommon.isClientLogin("MAC") ||
                utilsCommon.isClientLogin("WINDOWS")
              )
            )
              window.location.href = `${process.env.PUBLIC_URL}/login`;
            else {
              utilsClient.goMain();
            }
            return;
          // 저장된 세션 삭제 후 로그인 페이지로 이동
          case "ZOOM_ACCOUNT_NOT_USE_ECO":
            return;
          case "NOT_FOUND_USER":
            return;
          case "NOT_FOUND_DATA":
            break;
          case "BAD_REQUEST":
            break;
          case "INTERNAL_SERVER_ERROR":
          case "INVALID_USER_ID_PWD":
          default:
            // toasts.toastMsg(uuidv4(),errorData.errorMessage, 'error');
            //alert(errorData.errorMessage); //TODO
            break;
        }
      }
      se = {
        name: errorData.errorCode,
        message: errorData.errorMessage,
      };

      return Promise.reject(se);
    }

    se = {
      name: "INTERNAL_SERVER_ERROR",
      message: "INTERNAL_SERVER_ERROR",
    };
    return Promise.reject(se);
  }
);
export default axiosBlob;
